/**
 * Renders a QR code into every `.membership__card-qr[data-qr-value]` element
 * on the page -- currently only the Membership pricing cards. Loaded ONLY on
 * the Membership page template (see inc/scripts.php jctc_membership_qr_script()),
 * never bundled into the site-wide common.js entry.
 *
 * The QR value itself (a real event ticket URL) is resolved server-side on
 * every render, never cached -- see template-parts/membership-card.php.
 */
import qrcode from 'qrcode-generator';

function renderQrCode(el) {
    const value = el.getAttribute('data-qr-value');
    if (!value) return;

    // Type 0 = auto-detect the smallest QR version that fits the data;
    // error-correction level M balances scan reliability against QR density
    // for a URL-length payload printed at a small card size.
    const qr = qrcode(0, 'M');
    qr.addData(value);
    qr.make();

    el.innerHTML = qr.createSvgTag({ scalable: true });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.membership__card-qr[data-qr-value]').forEach(renderQrCode);
});
